import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of, timeout } from 'rxjs';
import { ErrorStateService } from '../services/common/error-state.service';
import { AuthService } from '../services/auth/auth.service';
import { RuntimeConfigService } from '../services/common/runtime-config.service';

export const errorPageGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const router = inject(Router);
  const errorStateService = inject(ErrorStateService);
  const config = inject(RuntimeConfigService);
  const auth = inject(AuthService);

  // Quick health check to see if backend is reachable
  return http.get(`${config.apiUrl()}/auth/csrf-token`, {
    withCredentials: true
  }).pipe(
    timeout(5000), // 5 second timeout
    map(() => {
      // Backend is reachable, clear error state and redirect away
      errorStateService.clearError();

      // Redirect to dashboard (auth guard will handle if not authenticated)
      router.navigateByUrl(auth.homeUrl());
      return false;
    }),
    catchError(() => {
      // Backend is not reachable, allow access to error page
      return of(true);
    })
  );
};
